import React, { useEffect, useState, useRef} from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const MiningEdit = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [updateData, setupdateData] = useState([]);
  const [periodType, setPeriodType] = useState("");
  const [Principal, setPrincipal] = useState("");
  const [errorMessage, setErrorMessage] = useState([]);
  const refSubmitDis = useRef();

  useEffect(() => {
    fetch(`https://api.velormall.com/api/admin/mining/view/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setPeriodType(
          data?.data?.period_type != null ? String(data?.data?.period_type) : ""
        );
        setPrincipal(
          data?.data?.principal != null ? String(data?.data?.principal) : ""
        );
      });
  }, [updateData]);

  const handleSubmitData = (event) => {
    event.preventDefault();
    refSubmitDis.current.setAttribute("disabled", true);
    setErrorMessage({});
    try {

      const formData = new FormData(event.currentTarget);

      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      axios
        .put(
          `https://api.velormall.com/api/admin/mining/update/${id}`,
          formData,
          config
        )
        .then((response) => {
          event.target.reset();
          toast.success(`${response?.data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setupdateData(response?.data);
          refSubmitDis.current.removeAttribute("disabled");
        })
        .catch((error) => {
          setErrorMessage(error?.response?.data?.errors)
          refSubmitDis.current.removeAttribute("disabled");
        });

    } catch (error) {

    }
  };



 return (
      <>
        <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
          <h6 className="page-title">Mining Update</h6>
          <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins"></div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 mb-30">
            <div className="card">
              <div className="card-body">
                <form onSubmit={handleSubmitData}>
                  <div className="row">
                    <div className="col-md-6 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Promotion Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="promotion_name"
                          placeholder="promotion name"
                          id="heading"
                          defaultValue={data?.promotion_name}
                        />
                        {errorMessage?.promotion_name && (
                          <span className="text-danger pt-2">
                            {errorMessage?.promotion_name?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Principal
                        </label>
                        <select
                          className="form-control"
                          name="principal"
                          id="role"
                          value={Principal}
                          onChange={(e) =>
                            setPrincipal(e.target.value)
                          }
                        >
                          <option selected disabled>
                            select
                          </option>
                          <option value="1"> Returns </option>
                          <option value="2"> Included </option>
                        </select>
                        {errorMessage?.principal && (
                          <span className="text-danger pt-2">
                            {errorMessage?.principal?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Period Time
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="period"
                          placeholder="period "
                          id="heading"
                          min="1"
                          defaultValue={data?.period}
                        />
                        {errorMessage?.period && (
                          <span className="text-danger pt-2">
                            {errorMessage?.period?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Period Type
                        </label>
                        <select
                          className="form-control"
                          name="period_type"
                          id="role"
                          value={periodType}
                          onChange={(e) =>
                            setPeriodType(e.target.value)
                          }
                        >
                          <option selected disabled>
                            select
                          </option>
                          <option value="Hours">Hours</option>
                          <option value="Day">Day</option>
                          <option value="Months">Months</option>
                        </select>
                        {errorMessage?.period_type && (
                          <span className="text-danger pt-2">
                            {errorMessage?.period_type?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Profit%
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="percentage"
                          placeholder="profit"
                          id="heading"
                          defaultValue={data?.percentage}
                        />
                        {errorMessage?.percentage && (
                          <span className="text-danger pt-2">
                            {errorMessage?.percentage?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Instant
                        </label>
                        <select
                          className="form-control"
                          name="instant"
                          id="role"
                          defaultValue={data?.instant || ""}
                        >
                          <option selected disabled>
                            select
                          </option>
                          <option value="1">Daily</option>
                          <option value="2">After</option>
                        </select>
                        {errorMessage?.instant && (
                          <span className="text-danger pt-2">
                            {errorMessage?.instant?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Minimum Amount
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="min_amount"
                          placeholder="min amount"
                          id="heading"
                          defaultValue={data?.min_amount}
                        />
                        {errorMessage?.min_amount && (
                          <span className="text-danger pt-2">
                            {errorMessage?.min_amount?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          maximum Amount
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="max_amount"
                          placeholder="max amount"
                          id="heading"
                          defaultValue={data?.max_amount}
                        />
                        {errorMessage?.max_amount && (
                          <span className="text-danger pt-2">
                            {errorMessage?.max_amount?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="expired_time" className="required">
                          Expired Time
                        </label>

                        <input
                          type="date"
                          className="form-control"
                          name="expired_time"
                          id="expired_time"
                          defaultValue={
                            data?.expired_time
                              ? new Date(data.expired_time)
                                .toISOString()
                                .split("T")[0]
                              : ""
                          }
                        />

                        {errorMessage?.expired_time && (
                          <span className="text-danger pt-2">
                            {errorMessage.expired_time.msg}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <button
                      ref={refSubmitDis}
                      type="submit"
                      className="btn btn-primary w-100 h-45"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};

export default MiningEdit;
